import { FETCH_FILTERS_SUCCESS } from './../const';

export default (json) => {
  return {type: FETCH_FILTERS_SUCCESS, json}
};
